// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-consist__table[data-v-3caefa46]{padding:12px 16px}.product-consist__table~.product-consist__consist[data-v-3caefa46]{margin-top:16px}.product-consist__consist-title[data-v-3caefa46]{font-family:var(--font-bold);margin:0;font-size:18px;line-height:30px}@media(max-width: 480px){.product-consist__consist-title[data-v-3caefa46]{font-size:16px;line-height:20px}}.product-consist__consist-desk[data-v-3caefa46]{margin:8px 0 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
